import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { formatPopularity } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden transition-colors hover:border-primary-300 cursor-pointer"
      title={`${movie.title} - 激情丛林在线观看`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}高清封面`}
          title={`${movie.title} 激情丛林 ${movie.type}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
          </span>
        </div>
        <span className="absolute top-2 left-2 flex items-center gap-1 bg-foreground-950/70 text-background-50 text-xs font-bold px-2 py-0.5 rounded-md">
          <i className="ri-star-fill text-accent-400 text-[10px]" aria-hidden="true"></i>
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-md">
          {movie.type}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-bold text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {movie.year} · {movie.region} · {movie.genres[0]}
        </p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-400">
          <span className="truncate pr-2">{movie.genres.join(" / ")}</span>
          <span className="flex items-center gap-1 shrink-0">
            <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
            {formatPopularity(movie.popularity)}
          </span>
        </div>
      </div>
    </Link>
  );
}